import AboutBtn from "../../../components/sub/AboutBtn";
import SubTitle from "../../../components/sub/SubTitle";

const AboutOrganization = () => {
  return (
    <>
      <SubTitle
        src={"/images/subTitle3.webp"}
        title={"조직구성도"}
        eng={"About us"}
      />
      <AboutBtn id={2} />
      <div className="relative w-full h-full px-[calc((100%-var(--container))/2)] mx-auto py-14 lg:py-28 xl:py-36">
        <div
          id="title"
          className="relative w-full h-fit text-center mb-10 xl:mb-14"
        >
          <h3 className="text-center">(주)카이노스바이오케미칼 조직구성도</h3>
        </div>

        <div
          data-aos="fade-up"
          className="relative w-full h-full mt-14 lg:mt-28 max-w-screen-xl mx-auto"
        >
          <img
            src="/images/aboutStructure.webp"
            alt="(주)카이노스바이오케미칼 조직구성도"
            className="!relative w-full h-full object-contain"
          />
        </div>
      </div>
    </>
  );
};

export default AboutOrganization;
